import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import CheckinConsoleLogin from "./CheckinConsoleLogin";
import CheckinConsoleLayout from "./CheckinConsoleLayout";
import CheckinConsoleEvents from "./CheckinConsoleEvents";
import CheckinScan from "./CheckinScan";

/**
 * Parent router for the volunteer check-in console.
 * /checkin-console/* routes live here.
 */
const CheckinConsole = () => {
  return (
    <Routes>
      <Route path="login" element={<CheckinConsoleLogin />} />

      <Route element={<CheckinConsoleLayout />}>
        <Route index element={<Navigate to="events" replace />} />
        <Route path="events" element={<CheckinConsoleEvents />} />
        <Route path="scan" element={<CheckinScan />} />
      </Route>

      <Route path="*" element={<Navigate to="events" replace />} />
    </Routes>
  );
};

export default CheckinConsole;